import {Component, OnInit} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import { Router } from '@angular/router';
import { AppConfigService } from '../../../../Services/app-config.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '../../../../Services/notification.service';
import { DateFilterService } from '../../../../Services/dateFilter.service';
import { ResponseModel } from '../../../../DataModels/response-model';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagerStateService } from '../../../../Services/pager-state.service';
import { NgbpaginationConfigService } from '../../../../Services/ngbpagination-config.service';
import {Title} from '@angular/platform-browser';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-item-pricing-list',
  templateUrl: './item-pricing-list.component.html',
  styleUrls: ['./item-pricing-list.component.css'],
  standalone: false
})
export class ItemPricingListComponent extends ListPageBase implements OnInit {
  constructor(
    private table: DataService,
    private toastr: NotificationService,
    private dateFilter: DateFilterService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService,
    private titleService: Title
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  itemPricingCount = 0;
  isLoaded = false;

  vm: any = [];




  ngOnInit() {
    this.restorePagerState();
    this.titleService.setTitle($localize`:Item Pricing List @@itemPricingList:Item Pricing List`);
    this.vm.list = [];
    this.getData();
  }




  getData() {
    let paramString = '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.table.getApiListData('item_pricing', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.itemPricingCount = result.totalRecords;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        // this.toastr.error($localize`:Error loading Bank Data @@errorloadingBankData:Error loading Bank Data`);
        console.log(error);
      },
      () => {}
    );
  }

  onNavigate(aID: string) {
    this.router.navigate(['admin/item-pricing-form', { id: aID }]);
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    let paramString = '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.table.getApiListData('item_pricing', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.itemPricingCount = result.totalRecords;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        // this.toastr.error($localize`:Error loading Bank Data @@errorloadingBankData:Error loading Bank Data`);
        console.log(error);
      },
      () => {}
    );
  }

  serverSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }
}
